import HTTP from '@/config/axios-config-erp'

const SrvGeneral = {
  // LISTA DE VALORES
  lovClte(payload) {
    return HTTP.post(`/wscomun/clte/lovClte`, payload).then(respuesta => {
      if (respuesta.status === 200) {
        return respuesta
      } else {
        console.error(respuesta)
        return respuesta
      }
    }).catch(error => {
      return error
    })
  },
  lovDic(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovDic`, payload).then(respuesta => {
      if (respuesta.status === 200) {
        return respuesta
      } else {
        console.error(respuesta)
        return respuesta
      }
    }).catch(error => {
      return error
    })
  },
  lovCentro(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovCentro`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  lovZon(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovZon`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  lovRep(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovRep`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getRepres(payload) {
    return HTTP.post(`/wscomun/portalinformes/getRepres`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  lovProv(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovProv`, payload).then(respuesta => {
      if (respuesta.status === 200) {
        return respuesta
      } else {
        console.error(respuesta)
        return respuesta
      }
    }).catch(error => {
      return error
    })
  },
  lovEmpresa(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovEmpresa`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getData(payload, headersDomain) {
    return HTTP.post(`/wscomun/portalinformes/getData`, payload, { headers: headersDomain }).then(response => {
      return response
    }).catch(error => {
      return error
    })
  },
  setEmpresa(payload) {
    return HTTP.post(`/wscomun/portalinformes/setEmpresa`, payload).then(response => {
      return response
    }).catch(error => {
      return error
    })
  },
  lovArt(payload) {
    return HTTP.post(`/wscomun/portalinformes/articulos`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  lovAlm(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovAlm`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  lovUbi(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovUbi`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  administracionAlmUbi(payload) {
    return HTTP.post(`/wscomun/portalinformes/administracionAlmacenesUbicaciones`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  actualizaAlmUbi(payload) {
    return HTTP.post(`/wscomun/portalinformes/actualizaAlmacenesUbicaciones`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  lovSucursalProveedor(payload) {
    return HTTP.post(`/wscomun/portalinformes/lovSucursalProveedor`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
}

export default SrvGeneral



// WEBPACK FOOTER //
// ./src/services/srv-general.js